import { Component, OnInit, ViewContainerRef, Input, ViewChild } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from './../shared/services/configuration';
import { HttpClientCustom } from './../shared/services/http.client';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'update-tenant',
    templateUrl: './updateTenant.html'
})
export class UpdateTenantComponent implements OnInit {
    @ViewChild('tenantForm') public tenantForm: NgForm;
    public tenantId;
    public _baseUrl: any;
    public lang: any = [];
    public modules: any = [];
    public buttonDisabled: any = false;
    public editTenantData: any;
    public displayName: string;
    public selectedLangItems = [];
    public itemLangList = [];
    public langSettings = {};
    public languages = [];

    public apps = [
        { name: 'Dev Update', value: 'DEV_UPDATE' }
        , { name: 'Dev skylark', value: 'DEV_SKYLARK' }
        , {}];

    public primaryAdmin: any = null;

    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _toaster: ToasterComponent, vcr: ViewContainerRef,
        public _location: Location,
        public translate: TranslateService,
        public _sanitizer: DomSanitizer) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.tenantId = localStorage.getItem('tenantId');
        this.getAllApps();
    }

    public ngOnInit() {
        this.getLanguage();
        this.loadTenantInfo();
        this.langSettings = {
            text: 'Select Language',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: '',
            primaryKey: 'id',
            labelKey: 'name',
            //badgeShowLimit: 5
        }

    }

    public getAllApps() {
        let self = this;
        let url = self._baseUrl + 'v1/superAdmin/mobAppManagement/getAllMobileApp';
        self.http.post(url, { page: 0, pageSize: 100 }).subscribe((result) => {
            self.apps = result.content;
        }, (error) => {
            console.log('Error:', error);
        })
    }

    public loadTenantInfo() {
        let that = this;
        let url = that._baseUrl + 'v1/superAdmin/tenant/loadTenantToEdit/' + this.tenantId;
        that.http.get(url).subscribe((result) => {
            that.editTenantData = result;
            that.modules = that.editTenantData.modules;
            that.editTenantData.modules = [];
            if (that.primaryAdmin == null) {
                that.primaryAdmin = {};
            }
            that.primaryAdmin.id = that.editTenantData.primaryAdminId;
            that.primaryAdmin.displayName = that.editTenantData.primaryAdminName;
            this.setTenantLang();
        }, (error: any) => {
            this.translate.get('notAbleToLoad').subscribe((msg) => {
                that._toaster.showError(msg);
            });
            that.goBack();
        });
    }

    setTenantLang() {

        for (let i = 0; i < this.editTenantData.languages.length; i++) {
            this.selectedLangItems.push(this.editTenantData.languages[i].sysLang);
        }
        this.languages=this.editTenantData.languages;
    }

    public primaryAdminSource(keyword: any) {
        let url = this._baseUrl + 'v1/superAdmin/tenant/searchEmployee/' + this.tenantId;
        if (keyword.trim()) {
            let payload: any = { searchString: keyword };
            return this.http.post(url, payload)
                .map((res) => {
                    return res;
                }, (error) => {
                    console.log(error);
                    return Observable.of([]);
                });
        } else {
            return Observable.of([]);
        }
    }

    public adminSelected() {
        if (this.primaryAdmin != null) {
            this.editTenantData.primaryAdminId = this.primaryAdmin.id;
        } else {
            this.editTenantData.primaryAdminId = null;
        }
    }

    public adminChanged(event) {
        if (typeof this.primaryAdmin === 'string' || this.primaryAdmin instanceof String) {
            this.tenantForm.control.setErrors({ incorrect: true });
        }
    }

    public autoCompleteListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.displayName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public updateTenant() {
        let that = this;
        this.populateSelectedModules();
        that.addLanguage();
        if (that.validateNewTenant() && that.validateSelectedModules()) {
            that.buttonDisabled = true;
            let url = that._baseUrl + 'v1/superAdmin/tenant/updateTenant';
            that.http.post(url, that.editTenantData).subscribe((result) => {
                this.translate.get('tenantUpdated').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
                that.buttonDisabled = false;
                setTimeout(() => { that.goBack(); }, 500)
            }, (error: any) => {
                that.buttonDisabled = false;
            });
        }
    }

    public validateSelectedModules(): boolean {
        if (this.editTenantData.selectedModules.length === 0) {
            this.translate.get('selectOneModule').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        } else {
            return true;
        }
    }

    public populateSelectedModules() {
        this.editTenantData.selectedModules = [];
        let mod: any;
        for (mod of this.modules) {
            if (mod.assigned) {
                this.editTenantData.selectedModules.push(mod.operation);
            }
        }
    }

    public validateNewTenant() {
        let that = this;
        if (that.editTenantData.timeZone.trim() === '') {
            this.translate.get('selectTimeZone').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        if (typeof this.primaryAdmin === 'string' || this.primaryAdmin instanceof String) {
            this.translate.get('selectPrimeAdmin').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        if (that.editTenantData.languages.length == 0&&that.editTenantData.languageId.length == 0) {
            this.translate.get('selectLanguage').subscribe((msg) => {
                this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    }

    public getLanguage() {
        let that = this;
        let url = that._baseUrl + 'v1/hub/sys/getAllLang';
        that.http.get(url).subscribe((result) => {
            that.lang = result;
            that.itemLangList = that.lang;
        }, (error) => {
            that.lang = [];
            console.log(error);
        });
    }

    public goBack() {
        this._location.back();
    }

    public setTenantLanguage() {
        for (let i = 0; i < this.editTenantData.languageIds.length; i++) {
            for (let j = 0; j < this.lang.length; j++) {
                if (this.editTenantData.languageIds[i] == this.lang[j].id) {
                    this.selectedLangItems.push(this.lang[j])
                }
            }
        }
    }

    public addLanguage() {
        this.editTenantData.languages = [];
        this.editTenantData.languageId=[];
        let added = false;
        for (let i = 0; i < this.selectedLangItems.length; i++) {
            added = false;
            for (let j = 0; j < this.languages.length; j++) {
                if (this.selectedLangItems[i].id == this.languages[j].sysLang.id) {
                    added = true;
                    this.editTenantData.languages.push(this.languages[j]);
                    break;
                }
            }
            if (!added) {
             this.editTenantData.languageId.push(this.selectedLangItems[i].id)
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/superAdmin/updateTenant.ts